import { useEffect, useCallback } from 'react';
import { useTabNavigationStore } from '../store/tabNavigationStore';

/**
 * Hook to manage Telegram BackButton based on tab navigation stack
 * Shows BackButton when stack depth > 1, hides when at root
 * Handles back navigation via popScreen()
 */
export const useTabBackButton = () => {
  const { activeTab, tabStacks, popScreen, getStackDepth } = useTabNavigationStore();

  const handleBackClick = useCallback(() => {
    popScreen();
  }, [popScreen]);

  useEffect(() => {
    const backButton = window.Telegram?.WebApp?.BackButton;

    if (!backButton) {
      return;
    }

    const stackDepth = getStackDepth();

    if (stackDepth > 1) {
      // Show back button and attach handler
      backButton.show();
      backButton.onClick(handleBackClick);
    } else {
      // Hide back button at root level
      backButton.hide();
    }

    // Cleanup: remove handler and hide button on unmount
    return () => {
      backButton.offClick(handleBackClick);
      backButton.hide();
    };
  }, [activeTab, tabStacks, handleBackClick, getStackDepth]);
};
